import { Property } from "@app/models/Property";
import { ContactApi } from "@app/services/apiServices/ContactApi";
import { PmcDataService } from '@app/services/pmc-data.service';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { RegistrationManagementIdHelperDialog } from "@app/pages/registration/registrationManagementIdHelper.component";
import { RegistrationAssociationIdHelperDialog } from "@app/pages/registration/registrationAssociationIdHelper.component";
import { RegistrationPropertyIdHelperDialog } from "@app/pages/registration/registrationPropertyIdHelper.component";
import { take } from "rxjs/operators";

/**
 * Created by mac85103 on 12/7/16.
 */
export class invalidIdObj {
    managementIdError: boolean;
    associationIdError: boolean;
    propertyIdError: boolean;
    searching: boolean;
}

@Component({
    selector: 'app-property-form-left',
    template: require('./propertyFormLeft.directive.html')
})
export class PropertyFormLeftComponent implements OnInit, OnChanges {
    @Input() property: Property;
    @Output() blurFunction = new EventEmitter();
    @Output() invalidCheck = new EventEmitter<any>();
    @Input() disableInputsProperty: boolean;
    @Input() disablePropertyId: boolean;
    @Input() anonymous: boolean;

    invalidObj: invalidIdObj;
    managementName: string;
    hoaName: string;
    hoaNameError: boolean;
    managementNameError: boolean;
    managementChanged: boolean;
    associationChanged: boolean;
    propertyChanged: boolean;

    constructor(@Inject(MatDialog) private dialog: MatDialog,
                @Inject(ContactApi) private ContactApi: ContactApi,
                @Inject(PmcDataService) private PmcDataService: PmcDataService) {
    }

    ngOnInit(): void {
        this.invalidObj = {
            managementIdError: false,
            associationIdError: false,
            propertyIdError: false,
            searching: false
        };

        if (this.property && this.property.hoa && this.property.hoa.pmc && this.property.hoa.pmc.couponId) {
            this.managementId();
        }

        if (this.property && this.property.hoa && this.property.hoa.couponId) {
            this.associationId();
        }

        if (this.property && this.property.couponId) {
            this.propertyId();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.invalidObj) { //Component has not been initiliazed yet
            if (changes.property?.previousValue?.hoa?.pmc?.couponId !== changes.property?.currentValue?.hoa?.pmc?.couponId
                && changes.property?.currentValue?.hoa?.pmc?.couponId !== undefined) {
                this.managementId();
            }
            if (changes.property?.previousValue?.hoa?.couponId !== changes.property?.currentValue?.hoa?.couponId
                && changes.property?.currentValue?.hoa?.couponId !== undefined) {
                this.associationId();
            }
            if (changes.property?.previousValue?.couponId !== changes.property?.currentValue?.couponId
                && changes.property?.currentValue?.couponId !== undefined) {
                this.propertyId();
            }
        }
    }

    managementIdHelper() {
        this.dialog.open(RegistrationManagementIdHelperDialog, {
            closeOnNavigation: true,
            disableClose: false,
        });
    }

    associationIdHelper() {
        this.dialog.open(RegistrationAssociationIdHelperDialog, {
            closeOnNavigation: true,
            disableClose: false,
        });
    }

    propertyIdHelper() {
        this.dialog.open(RegistrationPropertyIdHelperDialog, {
            closeOnNavigation: true,
            disableClose: false,
        });
    }

    managementId() {
        if (this.property.hoa.pmc.couponId === undefined && !this.managementChanged) {
            this.invalidObj.managementIdError = false;
        } else {
            this.managementChanged = true;
            this.invalidObj.managementIdError = !this.valid(/\d/, this.property.hoa.pmc.couponId);
            if (!this.invalidObj.managementIdError) {
                this.invalidObj.searching = true;
                this.invalidCheck.emit({ invalidObj: this.invalidObj });
                this.ContactApi.pmcOrganizationDetailsGET(this.anonymous, this.property.hoa.pmc.couponId).pipe(take(1)).subscribe((data) => {
                    this.invalidObj.searching = false;
                    this.invalidCheck.emit({ invalidObj: this.invalidObj });
                    if (data?.name) {
                        this.managementName = data.name;
                        this.PmcDataService.setPmcCoupon(this.property.hoa.pmc.couponId);
                        this.PmcDataService.setPmcName(this.managementName);
                        this.managementNameError = false;
                        if (this.property.hoa.couponId) {
                            this.associationId();
                        }
                    } else {
                        this.managementName = null;
                        this.managementNameError = true;
                        this.invalidObj.managementIdError = true;
                        this.invalidCheck.emit({ invalidObj: this.invalidObj });
                    }
                }, (err) => {
                    if (err === "Cancelled") {
                        return;
                    }
                    this.managementName = null;
                    this.managementNameError = true;
                    this.invalidObj.managementIdError = true;
                    this.invalidObj.searching = false;
                    this.invalidCheck.emit({ invalidObj: this.invalidObj });
                });
            } else {
                this.managementName = null;
                this.managementNameError = false;
            }
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    associationId() {
        if (this.property.hoa.couponId === undefined && !this.associationChanged) {
            this.invalidObj.associationIdError = false;
        } else {
            this.associationChanged = true;
            this.invalidObj.associationIdError = !(this.property.hoa.couponId && this.valid(/\d|[a-zA-Z]/, this.property.hoa.couponId));
            if (this.property.hoa.pmc.couponId && !this.invalidObj.associationIdError) {
                this.invalidObj.searching = true;
                this.invalidCheck.emit({ invalidObj: this.invalidObj });
                this.ContactApi.hoaOrganizationDetailsGET(this.anonymous, this.property.hoa.pmc.couponId, this.property.hoa.couponId).pipe(take(1)).subscribe((data) => {
                    this.invalidObj.searching = false;
                    this.invalidCheck.emit({ invalidObj: this.invalidObj });
                    if (data?.name) {
                        this.property.hoa.paymentSiteId = data.paymentSiteId;
                        this.hoaName = data.name;
                        this.hoaNameError = false;
                    } else {
                        this.property.hoa.paymentSiteId = null;
                        this.hoaName = null;
                        this.hoaNameError = true;
                        this.invalidObj.associationIdError = true;
                        this.invalidCheck.emit({ invalidObj: this.invalidObj });
                    }
                }, (err) => {
                    if (err === "Cancelled") {
                        return;
                    }
                    this.hoaName = null;
                    this.property.hoa.paymentSiteId = null;
                    this.hoaNameError = true;
                    this.invalidObj.associationIdError = true;
                    this.invalidObj.searching = false;
                    this.invalidCheck.emit({ invalidObj: this.invalidObj });
                })
            } else {
                this.property.hoa.paymentSiteId = null;
                this.hoaName = null;
                this.hoaNameError = false;
            }
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    propertyId() {
        if (this.property.couponId === undefined && !this.propertyChanged) {
            this.invalidObj.propertyIdError = false;
        } else {
            this.propertyChanged = true;
            this.invalidObj.propertyIdError = !(this.property.couponId && this.zeroCheck(this.property.couponId));
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    valid(pattern, value) {
        return pattern.test(value);
    }

    zeroCheck(value) {
        const a = value.replace(/[0 ]/g, ''); // Remove all 0 and spaces
        return a !== "" // Return true if empty string
    }
}

